exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".file-loader-dropzone{box-sizing:border-box;padding:20px;min-height:30vh;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;border:3px dashed grey}.file-loader-dropzone.active{border-style:solid}.track-importer-footer{height:60px;-ms-flex-negative:0;flex-shrink:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader!./~/less-loader!./editor/styles/FileLoader.less
// module id = 750
// module chunks = 0